import React, { Component } from 'react';
import { useHistory } from 'react-router-dom';

import { DelayLink } from '../../components';
import { images } from '../../settings';

class Logo extends Component {
  render() {
    const { menuNome, eventoMenu } = this.props;
    return (
      <div>
        {!!menuNome && (
          <DelayLink to="/">
            <img src={images.logo_white} width="109" className="logo-white" />
            <img src={images.logo} width="109" className="logo-sticky" />
          </DelayLink>
        )}
        {!menuNome && (
          <a
            href="#"
            onClick={() => {
              eventoMenu();
              const history = useHistory();
              history.push('/');
            }}
          >
            <img src={images.logo_white} width="109" className="logo-white" />
            <img src={images.logo} width="109" className="logo-sticky" />
          </a>
        )}
      </div>
    );
  }
}

export { Logo };
